import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import '../../assets/styles/About.css';
import { connect } from 'react-redux';
import { listConstants } from '../../actions/ConstantsActions';
import { HTML_PAGE } from '../../constants/globals';
import { scrollToNavigation } from '../../utils/utils';

const About = (props) => {
    const { listConstants: listConstantsAction } = props;

    useEffect(() => {
        listConstantsAction(HTML_PAGE.ABOUT);
        document.title = 'About » Askimam';
        scrollToNavigation();
    }, [listConstantsAction]);


    const { constants: aboutInfo } = props.constants;

    return (
        <div>
            <h2 className="page-title">About</h2>
            {aboutInfo ? (
                <div className="rendered-content" dangerouslySetInnerHTML={{ __html: aboutInfo[HTML_PAGE.ABOUT] }} />
            ) : (
                <div>Loading...</div>
            )}
        </div>
    );
};

About.propTypes = {
    constants: PropTypes.object.isRequired,
    listConstants: PropTypes.func.isRequired,
};

const mapStateToProps = ({ listConstantsReducer }) => ({
    constants: listConstantsReducer,
});

export default connect(mapStateToProps, { listConstants })(About);
